// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-continue {\n  text-align: center;\n}\n.profile-continue button {\n  border-radius: 10px;\n}", ""]);
// Exports
module.exports = exports;
